<template>
  <div class="home">
    <h1>{{ homeTitle }}</h1>
  </div>
</template>
<script>
import { HOME_TITLE } from '@/config/app'

export default {
  data () {
    return {
      homeTitle: HOME_TITLE,
    }
  },
  created () { },
  methods: {}
}
</script>
<style lang="less" scoped>
.home {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 111px);
}
</style>